let url = "";
let url_paginas_externas = "";
let url_admin = "";

if (process.env.NODE_ENV === "development") {
    url = "https://trio-api.test";
    url_paginas_externas = "http://localhost:3000/ext";
    url_admin = "http://localhost:3000";
} else {
    url = "https://api.riskin.com.br";
    url_paginas_externas = "https://painel.riskin.com.br/ext";
    url_admin = "https://painel.riskin.com.br";
}

export const Constants = {
    url: url,
    baseUrl: url + "/api/parceiro",
    url_paginas_externas: url_paginas_externas,
    url_admin,
};
